
import { GeneralService } from 'src/app/services/general.service';
import { NotificationService } from './../../../services/notification.service';
import { FormularioService } from './../../../services/formulario.service';
import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { AbstractControl, FormGroup, FormBuilder, Validators } from '@angular/forms';
import { GeneralComponent } from 'src/app/shared/general.component';
import { HttpErrorResponse } from '@angular/common/http';
import { TypeMessage } from 'src/app/entity/enum/enum-notification';
import { take } from 'rxjs/operators';
import { DropDownListDTO } from 'src/app/entity/dto/dropdownlist.component';

@Component({
    // tslint:disable-next-line: component-selector
    selector: 'app-cd003-card-I',
    templateUrl: './cd003-card-I.component.html'
})

export class Cd003CardIComponent extends GeneralComponent implements OnInit {
    public formulario?: FormGroup;
    public listSiteBeneficiamento?: Array<DropDownListDTO> = new Array<DropDownListDTO>();
    public listHibrido?: Array<DropDownListDTO> = new Array<DropDownListDTO>();
    public listPeneira?: Array<DropDownListDTO> = new Array<DropDownListDTO>();
    public listEquipUtil?: Array<DropDownListDTO> = new Array<DropDownListDTO>();
    public listSiloOrigem?: Array<DropDownListDTO> = new Array<DropDownListDTO>();
    public listSiloDestino?: Array<DropDownListDTO> = new Array<DropDownListDTO>();
    public listLinhaProcessamento?: Array<DropDownListDTO> = new Array<DropDownListDTO>();
    public listHibridoRnc?: DropDownListDTO[];
    public listEquipUtilBasica?: Array<DropDownListDTO> = new Array<DropDownListDTO>();
    public listPeneiraBasica?: Array<DropDownListDTO> = new Array<DropDownListDTO>();
    public listLoteDs: Array<DropDownListDTO> = new Array<DropDownListDTO>();

    public listSiteBeneficiamentoOriginal?: Array<DropDownListDTO> = new Array<DropDownListDTO>();
    public listHibridoOriginal?: Array<DropDownListDTO> = new Array<DropDownListDTO>();
    public listPeneiraOriginal?: Array<DropDownListDTO> = new Array<DropDownListDTO>();
    public listEquipUtilOriginal?: Array<DropDownListDTO> = new Array<DropDownListDTO>();
    public listSiloOrigemOriginal?: Array<DropDownListDTO> = new Array<DropDownListDTO>();
    public listSiloDestinoOriginal?: Array<DropDownListDTO> = new Array<DropDownListDTO>();
    public listEquipUtilBasicaOriginal?: Array<DropDownListDTO> = new Array<DropDownListDTO>();
    public listPeneiraBasicaOriginal?: Array<DropDownListDTO> = new Array<DropDownListDTO>();
    public listLinhaProcessamentoOriginal?: Array<DropDownListDTO> = new Array<DropDownListDTO>();
    public listLoteDsOriginal?: Array<DropDownListDTO> = new Array<DropDownListDTO>();

    public listTurno?: Array<DropDownListDTO> = new Array<DropDownListDTO>();
    public listTurnoOriginal?: Array<DropDownListDTO> = new Array<DropDownListDTO>();
    public listLinhaReprocessamentoOriginal?: Array<DropDownListDTO> = new Array<DropDownListDTO>();
    public listLinhaReprocessamento?: Array<DropDownListDTO> = new Array<DropDownListDTO>();
    public listSafra?: DropDownListDTO[];
    public listSafraOriginal: Array<DropDownListDTO> = new Array<DropDownListDTO>();
    dropdownLoteds = false;
    disabledInputLoteds = true;
    isLoteTBOpenForEditing = false;
    loteTbValidators = []
    regexLoteTb: RegExp = /^[\w]+$/;

    @Output() mkCalc = new EventEmitter();
    @Output() objCd001 = new EventEmitter();
    @Output() objQua007 = new EventEmitter();
    @Output() objPC003 = new EventEmitter();
    @Output() getDados = new EventEmitter();
    @Output() changeNameByEquipament = new EventEmitter();

    public isPTU: boolean;
    site = localStorage.getItem('data_site') 
    // tslint:disable-next-line: max-line-length
    constructor(protected formularioService: FormularioService, protected formBuilder: FormBuilder, protected notificationService: NotificationService, protected generalService: GeneralService) {
        super('Dados da Matéria-Prima', false);
        if (this.isComercial) {
            this.formulario = this.formBuilder.group({
                site_beneficiamento: [null, []],
                data_apontamento: [new Date().toLocaleDateString('pt-br'), []],
                hora_apontamento: [new Date().toLocaleTimeString('pt-br').substr(0, 5), []],
                safra: [null, [Validators.required, Validators.pattern(this.regexSafra)]],
                hibrido_rnc: [null, []],
                silo_origem: [null, []],
                lote_cs: [null, [Validators.pattern(this.regexLoteCs)]],
                lote_tb: [null, []],
                peneira: [null, []],
                equipamentos_utilizados: [null, []],
                turno: [null, []],

            });
        } else {
            this.formulario = this.formBuilder.group({
                site_beneficiamento: [null, []],
                data_apontamento: [new Date().toLocaleDateString('pt-br'), []],
                hora_apontamento: [new Date().toLocaleTimeString('pt-br').substr(0, 5), []],
                safra: [null, [Validators.required, Validators.pattern(this.regexSafra)]],
                hibrido_rnc: [null, []],
                silo_origem: [null, []],

                lote_cs: [{ value: null, disabled: true }, [Validators.required]],
                //peneira: [null, []],
                //equipamentos_utilizados: [null, []],
                numero_campo: [null, [Validators.required]],
                linha_processamento: [null, [Validators.required]],
                geracao: [null, []],
                prioridade: [null, []],
                contrato_juridico: [null, []],
                peneira_basica: [null, []],
                equipamentos_basica: [null, []],

            });
        }



    }

    public async ngOnInit(): Promise<void> {
        await this.getLists();
        this.listHibridoRnc = new Array<DropDownListDTO>();
    }

    public changeCollapse(): void {
        this.collapseCard = this.collapseCard ? false : true;
    }

    public hasErrorFormControl(campoFormulario?: AbstractControl): string {
        return this.formularioService.hasErrorFormControl(campoFormulario);
    }

    async getLists(): Promise<void> {
        await Promise.all([
            this.getListSiteBeneficiamento(),
            this.getListHibrido(),
            this.getListPeneira(),
            this.getListEquipUtil(),
            this.getListSiloOrigem(),
            this.getListLinhaProcessamento(),
            this.getListEquipUtilBasica(),
            this.getListPeneiraBasica(),
            this.getListSafra(),
            this.removeFieldsFromComercial()
        ]);
        this.getListTurno();
    }

    
    async getDataQua007bySafra() {
        const safra = this.formulario.controls.safra.value
        const numeroCampo = this.formulario.controls.numero_campo.value
        if ((safra != '' && safra != null) && (numeroCampo != '' && numeroCampo != null)) {
            const event = {
                safra,
                numero_campo: numeroCampo
            }
            this.objQua007.emit(event);
        } else {
            this.formulario.get('numero_campo')?.setValue("");
        }
    }

    getPC003Data() {
        // const contratoJuridico = this.formulario.get('contrato_juridico')?.value.trim()?.toUpperCase() as string;
        const safra = this.formulario.controls.safra.value
        const numeroCampo = this.formulario.controls.numero_campo.value
        // if (contratoJuridico != '' && contratoJuridico != null) {
        //     this.objPC003.emit(contratoJuridico)
        // }
        // else
        if ((safra != '' && safra != null) && (numeroCampo != '' && numeroCampo != null)) {
            this.objPC003.emit({ contratoJuridico: null, safra, numeroCampo });
            this.getListLoteDs(safra, numeroCampo);
        }

    }


    async getListSiteBeneficiamento(): Promise<void> {
        this.listSiteBeneficiamento = this.generalService.getListSiteRecebimento();
        this.listSiteBeneficiamentoOriginal = this.listSiteBeneficiamento;
        // await this.formularioService.getListDropDownList('qua007', 'site_origem').pipe(take(1)).toPromise().then(response => {
        //     if (!!response?.data) {
        //         this.listSiteBeneficiamento = this.generalService.orderByDropDownList(response.data as DropDownListDTO[]);
        //         this.listSiteBeneficiamentoOriginal = this.listSiteBeneficiamento;
        //     }
        // }).catch(async (error: HttpErrorResponse) => {
        //     this.notificationService.showNotificationError(error, '', TypeMessage.ListErrorSiteBeneficiamento);
        // });
    }

    async getListHibrido(): Promise<void> {
        await this.formularioService.getListDropDownList('qua007', 'hibrido_rnc').pipe(take(1)).toPromise().then(response => {
            if (!!response?.data) {
                this.listHibrido = this.generalService.orderByDropDownList(response.data as DropDownListDTO[]);
                this.listHibridoOriginal = this.listHibrido;
            }
        }).catch(async (error: HttpErrorResponse) => {
            this.notificationService.showNotificationError(error, '', TypeMessage.ListErrorHibrido);
        });
    }

    async getListSafra(): Promise<void> {
        await this.formularioService
          .getListDropDownList('qua007', 'safra')
          .pipe(take(1))
          .toPromise()
          .then((response) => {
            if (!!response?.data) {
              this.listSafra = this.generalService.orderByDropDownList(
                response.data as DropDownListDTO[]
              );
              this.listSafraOriginal = this.listSafra;
            }
          })
          .catch(async (error: HttpErrorResponse) => {
            this.notificationService.showNotificationError(
              error,
              '',
              TypeMessage.ListErrorSafra
            );
          });
      }
    
      async createFilterSafra(value?: string): Promise<void> {
        if (!!value && value.length > 0) {
          if (
            this.listSafraOriginal.filter((x) =>
              x.name?.toLowerCase().includes(value?.toLowerCase())
            ).length > 0
          ) {
            this.listSafra = this.listSafraOriginal.filter((x) =>
              x.name?.toLowerCase().includes(value?.toLowerCase())
            );
          } else {
            this.listSafra = this.listSafraOriginal;
          }
        } else {
          this.listSafra = this.listSafraOriginal;
        }
      }

    async getListPeneira(): Promise<void> {
        await this.formularioService.getListDropDownList('cd003', 'peneira').pipe(take(1)).toPromise().then(response => {
            if (!!response?.data) {
                this.listPeneira = this.generalService.orderByDropDownList(response.data as DropDownListDTO[]);
                this.listPeneiraOriginal = this.listPeneira;
            }
        }).catch(async (error: HttpErrorResponse) => {
            this.notificationService.showNotificationError(error, '', TypeMessage.ListErrorPeneira);
        });
    }

    async getListPeneiraBasica(): Promise<void> {
        await this.formularioService.getListDropDownList('cd003', 'peneira_basica').pipe(take(1)).toPromise().then(response => {
            if (!!response?.data) {
                this.listPeneiraBasica = this.generalService.orderByDropDownList(response.data as DropDownListDTO[]);
                this.listPeneiraBasicaOriginal = this.listPeneiraBasica;
            }
        }).catch(async (error: HttpErrorResponse) => {
            this.notificationService.showNotificationError(error, '', TypeMessage.ListErrorPeneira);
        });
    }

    async getListLinhaProcessamento(): Promise<void> {
        await this.formularioService.getListDropDownList('cd003', 'linha_processamento').pipe(take(1)).toPromise().then(response => {
            if (!!response?.data) {
                this.listLinhaProcessamento = this.generalService.orderByDropDownList(response.data as DropDownListDTO[]);
                this.listLinhaProcessamentoOriginal = this.listLinhaProcessamento;
            }
        }).catch(async (error: HttpErrorResponse) => {
            this.notificationService.showNotificationError(error, '', TypeMessage.ListErrorPeneira);
        });
    }

    async getListEquipUtilBasica(): Promise<void> {
        await this.formularioService.getListDropDownList('cd003', 'equipamentos_basica').pipe(take(1)).toPromise().then(response => {
            if (!!response?.data) {
                this.listEquipUtilBasica = this.generalService.orderByDropDownList(response.data as DropDownListDTO[]);
                this.listEquipUtilBasicaOriginal = this.listEquipUtilBasica;
            }
        }).catch(async (error: HttpErrorResponse) => {
            this.notificationService.showNotificationError(error, '', TypeMessage.ListErrorEquipUtil);
        });
    }

    async getListEquipUtil(): Promise<void> {
        await this.formularioService.getListDropDownList('cd003', 'equipamentos_utilizados').pipe(take(1)).toPromise().then(response => {
            if (!!response?.data) {
                this.listEquipUtil = this.generalService.orderByDropDownList(response.data as DropDownListDTO[]);
                this.listEquipUtilOriginal = this.listEquipUtil;
                const areaSelected = localStorage.getItem('area-select');
        if (areaSelected === 'Comercial') {
            const indexesToRemove = [0, 1, 5, 6];
            for (let i = indexesToRemove.length - 1; i >= 0; i--) {
                this.listEquipUtil.splice(indexesToRemove[i], 1);
            }
        }
        return this.listEquipUtil;
            }
        }).catch(async (error: HttpErrorResponse) => {
            this.notificationService.showNotificationError(error, '', TypeMessage.ListErrorEquipUtil);
        });
    }


    async removeFieldsFromComercial(): Promise<DropDownListDTO[]> {
        const areaSelected = localStorage.getItem('area-select');
        if (areaSelected === 'Comercial') {
            const indexesToRemove = [0, 1, 6, 7];
            for (let i = indexesToRemove.length - 1; i >= 0; i--) {
                this.listEquipUtil.splice(indexesToRemove[i], 1);
            }
        }
        return this.listEquipUtil;
    }

    async getListSiloOrigem(): Promise<void> {
        await this.formularioService.getListDropDownList('cd003', 'silo_origem', this.site).pipe(take(1)).toPromise().then(response => {
            if (!!response?.data) {
                this.listSiloOrigem = this.generalService.orderByDropDownList(response.data as DropDownListDTO[]);
                this.listSiloOrigemOriginal = this.listSiloOrigem;
            }
        }).catch(async (error: HttpErrorResponse) => {
            this.notificationService.showNotificationError(error, '', TypeMessage.ListErrorSiloOrigem);
        });
    }


    async getListSiloDestino(): Promise<void> {
        await this.formularioService.getListDropDownList('cd003', 'silo_destino', this.site).pipe(take(1)).toPromise().then(response => {
            if (!!response?.data) {
                this.listSiloDestino = this.generalService.orderByDropDownList(response.data as DropDownListDTO[]);
                this.listSiloDestinoOriginal = this.listSiloOrigem;
            }
        }).catch(async (error: HttpErrorResponse) => {
            this.notificationService.showNotificationError(error, '', TypeMessage.ListErrorSiloOrigem);
        });
    }

    async createFilterSiteBeneficiamento(value?: string): Promise<void> {
        if (!!value && value.length > 0) {
            if (this.listSiteBeneficiamentoOriginal.filter(x => x.name?.toLowerCase().includes(value?.toLowerCase())).length > 0) {
                this.listSiteBeneficiamento = this.listSiteBeneficiamentoOriginal.filter(x => x.name?.toLowerCase().includes(value?.toLowerCase()));
            } else {
                this.listSiteBeneficiamento = this.listSiteBeneficiamentoOriginal;
            }
        } else {
            this.listSiteBeneficiamento = this.listSiteBeneficiamentoOriginal;
        }
        // this.filteredOptionsSite = this.formulario.get('site_beneficiamento').valueChanges
        //     .pipe(
        //         startWith(''),
        //         map(value => this.generalService._filterDropDownList(this.listSiteBeneficiamento, value))
        //     );
    }

    async createFilterHibrido(value?: string): Promise<void> {
        if (!!value && value.length > 0) {
            if (this.listHibridoOriginal.filter(x => x.name?.toLowerCase().includes(value?.toLowerCase())).length > 0) {
                this.listHibrido = this.listHibridoOriginal.filter(x => x.name?.toLowerCase().includes(value?.toLowerCase()));
            } else {
                this.listHibrido = this.listHibridoOriginal;
            }
        } else {
            this.listHibrido = this.listHibridoOriginal;
        }
        // this.filteredOptionsHibrido = this.formulario.get('hibrido_rnc').valueChanges
        //     .pipe(
        //         startWith(''),
        //         map(value => this.generalService._filterDropDownList(this.listHibrido, value))
        //     );
    }

    async createFilterPeneira(value?: string): Promise<void> {
        if (!!value && value.length > 0) {
            if (this.listPeneiraOriginal.filter(x => x.name?.toLowerCase().includes(value?.toLowerCase())).length > 0) {
                this.listPeneira = this.listPeneiraOriginal.filter(x => x.name?.toLowerCase().includes(value?.toLowerCase()));
            } else {
                this.listPeneira = this.listPeneiraOriginal;
            }
        } else {
            this.listPeneira = this.listPeneiraOriginal;
        }

        // this.filteredOptionsPeneira = this.formulario.get('peneira').valueChanges
        //     .pipe(
        //         startWith(''),
        //         map(value => this.generalService._filterDropDownList(this.listPeneira, value))
        //     );
    }

    async createFilterEquipUtil(value?: string): Promise<void> {
        if (!!value && value.length > 0) {
            if (this.listEquipUtilOriginal.filter(x => x.name?.toLowerCase().includes(value?.toLowerCase())).length > 0) {
                this.listEquipUtil = this.listEquipUtilOriginal.filter(x => x.name?.toLowerCase().includes(value?.toLowerCase()));
            } else {
                this.listEquipUtil = this.listEquipUtilOriginal;
            }
        } else {
            this.listEquipUtil = this.listEquipUtilOriginal;
        }

        // this.filteredOptionsEquipUtil = this.formulario.get('equipamentos_utilizados').valueChanges
        //     .pipe(
        //         startWith(''),
        //         map(value => this.generalService._filterDropDownList(this.listEquipUtil, value))
        //     );
    }

    async createFilterSiloOrigem(value?: string): Promise<void> {
        if (!!value && value.length > 0) {
            if (this.listSiloOrigemOriginal.filter(x => x.name?.toLowerCase().includes(value?.toLowerCase())).length > 0) {
                this.listSiloOrigem = this.listSiloOrigemOriginal.filter(x => x.name?.toLowerCase().includes(value?.toLowerCase()));
            } else {
                this.listSiloOrigem = this.listSiloOrigemOriginal;
            }
        } else {
            this.listSiloOrigem = this.listSiloOrigemOriginal;
        }

        // this.filteredOptionsSiloOrigem = this.formulario.get('silo_origem').valueChanges
        //     .pipe(
        //         startWith(''),
        //         map(value => this.generalService._filterDropDownList(this.listSiloOrigem, value))
        //     );
    }

    async makeCalculations(): Promise<void> {
        this.mkCalc.emit();
    }

    async getCd001Data(): Promise<void> {
        this.objCd001.emit();
    }

    async changeNameByEquip(): Promise<void> {
        this.objCd001.emit();
    }

    async getListLoteDs(safra: string, numeroCampo: string): Promise<void> {
        await this.formularioService.getListDropDownLoteDS(safra, numeroCampo).pipe(take(1)).toPromise().then(response => {
            if (!!response?.data && response.data.length > 0) {
                this.listLoteDs = this.generalService.orderByDropDownList(response.data.map((item, i) => { return { name: item.lote_ds } }) as DropDownListDTO[]);
                this.listLoteDsOriginal = this.listLoteDs;
                this.dropdownLoteds = true;
                this.formulario.get("lote_cs").enable();
                this.formulario.get("lote_cs").updateValueAndValidity();
            }
            else {
                this.listLoteDs = []
                this.dropdownLoteds = false;
                this.formulario.get("lote_cs").enable();
                this.formulario.get("lote_cs").updateValueAndValidity();
            }
        }).catch(async (error: HttpErrorResponse) => {
            this.notificationService.showNotificationError(error, '', TypeMessage.ListErrorPeneira);
        });

    }


    async getListTurno(): Promise<void> {
        await this.formularioService.getListDropDownList('cd001_repasse', 'turno').pipe(take(1)).toPromise().then(response => {
            if (!!response?.data) {
                this.listTurno = this.generalService.orderByDropDownList(response.data as DropDownListDTO[]);
                this.listTurnoOriginal = this.listTurno;
            }
        }).catch(async (error: HttpErrorResponse) => {
            this.notificationService.showNotificationError(error, '', TypeMessage.ListErrorTurno);
        });
    }

    async createFilterLinhaReprocessamento(value?: string): Promise<void> {
        if (!!value && value.length > 0) {
            if (this.listLinhaReprocessamentoOriginal.filter(x => x.name?.toLowerCase().includes(value?.toLowerCase())).length > 0) {
                this.listLinhaReprocessamento = this.listLinhaReprocessamentoOriginal.filter(x => x.name?.toLowerCase().includes(value?.toLowerCase()));
            } else {
                this.listLinhaReprocessamento = this.listLinhaReprocessamentoOriginal;
            }
        } else {
            this.listLinhaReprocessamento = this.listLinhaReprocessamentoOriginal;
        }
    }

    async createFilterTurno(value?: string): Promise<void> {
        if (!!value && value.length > 0) {
            if (this.listTurnoOriginal.filter(x => x.name?.toLowerCase().includes(value?.toLowerCase())).length > 0) {
                this.listTurno = this.listTurnoOriginal.filter(x => x.name?.toLowerCase().includes(value?.toLowerCase()));
            } else {
                this.listTurno = this.listTurnoOriginal;
            }
        } else {
            this.listTurno = this.listTurnoOriginal;
        }
    }

    async getDadosMateria() {
        this.getDados.emit();
    }

    async getQua042LotesTBFromLoteCS() {
      let loteOrigem: string = this.formulario.get('lote_cs')?.value;
      if (loteOrigem === "" || loteOrigem === "N/A") {
        this.formulario.get('lote_tb')?.setValue("");
        this.formulario.get('lote_cs')?.setValue("");
        this.allowEditionOfLoteTb();
        return;
      }
 
      let response = await this.formularioService.getLotesTb(loteOrigem);
 
      if (response['data'].length === 1) {
        this.formulario.get('lote_tb')?.setValue(response['data'][0]['lote_saida']);
      } else if (response['data'].length > 1) {
        let loteTbList = [];
        response['data'].forEach(el => {
            loteTbList.push(el['lote_saida']);
        });
        let lotesTbString = loteTbList.join('; ')
        this.formulario.get('lote_tb')?.setValue(lotesTbString);
      } else {      
        this.formulario.get('lote_tb')?.setValue("");
        this.allowEditionOfLoteTb();
        return;
      }

      this.allowEditionOfLoteTb(false);      
    }

    allowEditionOfLoteTb(allow: boolean = true) {
        this.isLoteTBOpenForEditing = allow;
        if (!allow) {
          this.formulario.get('lote_tb')?.clearValidators();
          this.formulario.get('lote_tb')?.updateValueAndValidity();
          return;
        }
        this.formulario.get('lote_tb')?.setValidators(Validators.pattern(this.regexLoteTb));
        this.formulario.get('lote_tb')?.updateValueAndValidity();
      }
    }

